<div [ngClass]="{ 'container-fluid': !fullWidth }">
  <div
    [ngClass]="{ 'tw-flex tw-flex-wrap tw-gap-10 lg:tw-flex-nowrap': column > 1 }"
    class="tw-py-10"
    [class.tw-min-h-[60vh]]="headerType === 'h1'"
    [class.!tw-pt-0]="headerType === 'h2'"
  >
    <!-- Main Content -->
    <div class="tw-min-w-0 tw-flex-auto">
      <div class="tw-mb-5 tw-flex tw-flex-wrap tw-items-start tw-gap-5 md:tw-flex-nowrap">
        <div>
          @if (productBadge) {
            <product-badge [name]="productBadge"></product-badge>
          }
          @if (productBadges) {
            <div class="tw-flex tw-gap-4">
              @for (badge of productBadges; track badge) {
                <product-badge [name]="badge"></product-badge>
              }
            </div>
          }

          @if (headerType === 'h1') {
            <h1 class="p-text-h2 tw-mb-0">{{ name | translate }}</h1>
          }
          @if (headerType === 'h2') {
            <h2 class="p-text-h3 tw-mb-0">{{ name | translate }}</h2>
          }
          @if (description) {
            <div class="tw-mt-1">{{ description | translate }}</div>
          }
        </div>

        <!-- Page actions next to name -->
        <ng-content select="[action]"></ng-content>
      </div>

      <ng-content></ng-content>
    </div>

    <!-- Secondary -->
    <div class="tw-flex-auto lg:tw-w-[320px] lg:tw-flex-none">
      <ng-content select="[secondary]"></ng-content>
    </div>
  </div>
</div>
